export default "__VITE_ASSET__7e3242f0__"